import org.jetbrains.compose.resources.stringResource

class A {
    init {

    }
}